module.exports = __webpack_public_path__ + "media/luxury-2026/kingdom-chef-kitchen-960-cc25a45c.jpg";